"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.enumMessagesMaker = exports.invalidMessageMaker = void 0;
const invalidMessageMaker = (validationPhrases, str) => ({
    message: validationPhrases('{{label}} is invalid', {
        label: validationPhrases(str),
    }),
});
exports.invalidMessageMaker = invalidMessageMaker;
const enumMessagesMaker = (validationPhrases, str) => ({
    errorMap: () => ({
        message: validationPhrases('{{label}} is invalid', {
            label: validationPhrases(str),
        }),
    }),
});
exports.enumMessagesMaker = enumMessagesMaker;
//# sourceMappingURL=index.js.map